import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/i_betu_spottal.webp")